export default __webpack_public_path__ + "static/SharpGroteskSmBold20-Regular-37835c062225b065a017be70edfd2d9b.woff2";